import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useFieldArray } from 'react-hook-form';
import PropTypes from 'prop-types';
import { AddSubsetButton } from '@/components/parameter/buttons/AddSubsetButton.jsx';
import { ParameterSubsetGroup } from '@/components/parameter/subsets/ParameterSubsetGroup.jsx';
import { createEmptySubset } from '@/helpers/parameter/parameterSubsets.js';
import { parameterSubsetListStyles } from '@/themes/commonStyles';

const StyledSubsetList = styled(Box)(parameterSubsetListStyles);

export const ParameterSubsetList = ({ source = 'subsets' }) => {
    const { fields, append, remove } = useFieldArray({ name: source, keyName: 'fieldKey' });

    return (
        <StyledSubsetList>
            <AddSubsetButton onAdd={() => append(createEmptySubset())} />
            {fields.map((field, index) => (
                <ParameterSubsetGroup key={field.fieldKey} source={`${source}.${index}`} depth={0} onRemove={() => remove(index)} />
            ))}
        </StyledSubsetList>
    );
};

ParameterSubsetList.propTypes = {
    source: PropTypes.string,
};
